import React from 'react';

class CategoryComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      option: "",
      clickCount: 0
    };
    this.handleClick = this.handleClick.bind(this);
  }

  getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }

  handleClick() {
    this.setState(prevState => ({
      option: this.props.options[this.getRandomInt(this.props.options.length)],
      clickCount: prevState.clickCount + 1
    }));
  }

  render() {
    const { category } = this.props;
    const { option, clickCount } = this.state;
    const hasResult = clickCount > 0;
    const searchStr = "https://www.youtube.com/results?search_query=" + option.replace(/\s/g, '+');

    const teaseText =
      clickCount > 7 ? "he raaammm control" :
      clickCount > 4 ? "Ah, you are so choosy today" :
      null;

    return (
      <div className="category-card" onClick={this.handleClick}>
        <div className="card-top">
          <span className="card-label">{category}</span>
        </div>
        <div className="card-divider" />

        <div className="card-content">
          {hasResult
            ? <div className="card-recipe">{option}</div>
            : <div className="card-prompt">Tap to discover</div>
          }
        </div>

        {teaseText && <div className="card-tease">{teaseText}</div>}

        {hasResult && (
          <a
            href={searchStr}
            className="yt-link"
            target="_blank"
            rel="noopener noreferrer"
            onClick={e => e.stopPropagation()}
          >
            <img src="youtube-svgrepo-com.svg" alt="YouTube" />
            Watch recipe
          </a>
        )}
      </div>
    );
  }
}

export default CategoryComponent;
